<template>
  <div id="tab7">
    <div v-if="showPreRegister" class="mode-panel-container row block-spacing">
      <SectionTitle
        content="Enviado para Firma"
        :has-line="true"
        class="mr-3 col-12"
      />

      <SignaturePanel
        id="firstSignaturePanel"
        ref="firstSignaturePanel"
        class="my-2 col-12"
        :positions="options.positions"
        :signatureTypes="options.signatureTypes"
        :isPositionReadOnly="true"
        :defaultPositionValue="getInternalPosition"
        :isNameReadOnly="true"
        :defaultNameValue="getCurrentUserName"
        :isDisabled="isReadOnlyMode"
        :attendanceGroupId="18"
      ></SignaturePanel>
      <SignaturePanel
        id="secondSignaturePanel"
        ref="secondSignaturePanel"
        class="my-2 col-12"
        :positions="options.positions"
        :signatureTypes="options.signatureTypes"
        :attendanceGroupId="1"
        :isDisabled="isReadOnlyMode"
      ></SignaturePanel>
    </div>
    <div v-if="showHistory">
      <div>
        <SectionTitle content="Historial de Firma" :has-line="true" />
        <time-line class="mt-4">
          <custom-result-not-found
            v-if="dataSign.length == 0"
            :text="'No cuenta con firma en el sistema.'"
          />
          <div v-for="(item, index) in dataSign" :key="index">
            <time-line-item class="custom-time-line rounded">
              <template #icon>
                <div>
                  <img src="@/assets/img/sign.svg" />
                </div>
              </template>
              <template #date>
                <div class="date-container">
                  <div class="color-black font-16 font-weight-bold fulldate">
                    {{ item.signatureDate | date }}
                  </div>
                  <div class="color-black font-12 font-weight-bold hour">
                    {{ item.signatureDate | hour }}
                  </div>
                </div>
              </template>
              <div class="row mx-1">
                <div class="col col-md-2">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Firmado en:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.signatureSource }}
                  </div>
                </div>
                <div class="col col-md-2">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Nombre:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.name }}
                  </div>
                </div>
                <div class="col col-md-2">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Tipo de Firma:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.signatureType }}
                  </div>
                </div>
                <div class="col col-md-3">
                  <div class="color-gray-6 font-14 font-weight-normal ml">
                    Aceptado por:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value ml"
                  >
                    {{ item.acceptedBy }}
                  </div>
                </div>
                <div class="col col-md-1 d-flex justify-content-end">
                  <div class="vertical-line"></div>
                </div>
                <div class="col col-md-2">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Representante:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{
                      item.attendanceGroupId === 0 ||
                      item.attendanceGroupId === 13
                        ? 'Otras personas con experiencia o peritaje'
                        : item.attendanceGroup
                    }}
                  </div>
                </div>
              </div>
            </time-line-item>
          </div>
        </time-line>
      </div>
    </div>
    <div v-if="showPostRegister" class="mode-panel-container row block-spacing">
      <SectionTitle
        content="Enviado para Firma"
        :has-line="true"
        class="mr-3 col-12"
      />
      <SignaturePanel
        v-for="(item, index) in pendingSignature"
        :id="`signature-panel-${index}`"
        ref="signature-panel"
        :key="index"
        class="my-2 col-12"
        :positions="[getPosition(item)]"
        :signatureTypes="options.signatureTypes"
        :isPositionReadOnly="true"
        :defaultPositionValue="getPosition(item)"
        :isNameReadOnly="true"
        :defaultNameValue="item.name"
        :attendanceGroupId="item.attendanceGroupId"
      ></SignaturePanel>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers(
  '$_student'
);
import { SectionTitle } from '@/components/pei/shared/';
import SignaturePanel from '@/components/student/registry/components/tab7/SignaturePanel';
import signatureService from '@/services/signatures';
import store from '@/store/index';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import StudentService from '@/services/student';
import CustomCallout from '@/components/common/CustomCallout';
import alertMixin from '@/mixin/alert.mixin';
import { SignatureSources } from '@/utils/constants/signature/signatureSources';
import StudentStatuses from '@/utils/constants/student/studentStatuses.js';
import CustomResultNotFound from 'custom-result-not-found';
import RegistryTabNumber from '@/utils/constants/student/registryTabNumber';

export default {
  name: 'Tab7',
  mixins: [alertMixin],
  components: {
    SectionTitle,
    SignaturePanel,
    TimeLine,
    TimeLineItem,
    CustomCallout,
    CustomResultNotFound,
  },
  data() {
    return {
      internalPosition: {},
      options: {
        positions: [],
        signatureTypes: [],
      },
      dataSign: [],
      isReadOnlyMode: false,
      sourceTypeId: 0,
      digitalSignatureFlag: false,
    };
  },
  async mounted() {
    await this.getDigitalSignatureFlag();
    this.sourceTypeId = SignatureSources.registration;
    await this.getPositions();
  },
  computed: {
    ...mapState(['studentPreRegistryValidations']),
    ...mapGetters({
      isMobile: 'getIsMobileDensity',
      user: '$_user/fullProfile',
    }),
    getInternalPosition() {
      return this.internalPosition;
    },
    showPreRegister() {
      if (
        this.dataSign.length == 0 &&
        this.digitalSignatureFlag &&
        store.getters.HasPermission('eduesp.preregister.digitalsignatureaccess')
      )
        return true;
      return false;
    },
    showHistory() {
      if (
        this.dataSign.length == 0 &&
        this.digitalSignatureFlag &&
        store.getters.HasPermission('eduesp.preregister.digitalsignatureaccess')
      ) {
        return false;
      } else {
        const result = this.dataSign.find(
          (item) => item.signatureType === '' || item.signatureType === null
        );
        if (result) {
          return false;
        } else {
          return true;
        }
      }
    },
    showPostRegister() {
      const result = this.dataSign.find(
        ({ signatureType }) => signatureType === '' || signatureType === null
      );
      if (result) {
        return true;
      } else {
        return false;
      }
    },
    dataSigned() {
      return this.dataSign.filter(
        ({ signatureType }) => signatureType !== '' && signatureType !== null
      );
    },
    pendingSignature() {
      return this.dataSign.filter(
        ({ signatureType }) => (signatureType === '') | (signatureType === null)
      );
    },
    getCurrentUserName() {
      return `${this.userProfile.firstname} ${this.userProfile.lastpaternalname}`;
    },
    studentPreRegistry() {
      return this.$store.getters['$_student/getStudentPreRegistry'];
    },
    isInvalid() {
      return (
        this.studentPreRegistryValidations.filter(
          (x) => x === RegistryTabNumber.SignatureProcess
        ).length > 0
      );
    },
  },
  async activated() {
    store.commit('setSaveMethod', this.save);

    //if is invalid call save method to raise validations
    if (this.isInvalid) {
      await this.raiseValidate();
    }

    StudentService.getHistorySign(store.getters.SelectedStudent.studentId).then(
      (data) => {
        this.dataSign = data.data;
        console.table(this.dataSign);
        this.sourceTypeId = this.showPostRegister
          ? SignatureSources.postRegistration
          : SignatureSources.registration;
        this.getSignatureTypes(this.sourceTypeId);

        this.$emit('set-button-save-visibility', !this.showHistory);
      }
    );
  },
  methods: {
    async raiseValidate() {
      if (this.showPreRegister) {
        await this.preRegistrationValidate();
      }
      if (this.showPostRegister) {
        await this.postRegistrationValidate();
      }
    },
    goToPostRegisterTab() {
      this.$emit('select-tab', 6);
    },
    async getDigitalSignatureFlag() {
      const res = await StudentService.getDigitalSignatureFlag(
        store.getters.SelectedStudent.studentId
      );
      this.digitalSignatureFlag = res.data;
    },
    async getPositions() {
      const res = await signatureService.getAvailablePositions(1);
      this.options.positions = res.data.map((p) => ({
        id: p.signaturePositionId,
        name: p.signaturePositionName,
      }));
      const internalPositionRes = await signatureService.getAvailablePositions(
        18
      );
      this.internalPosition = internalPositionRes.data.map((p) => ({
        id: p.signaturePositionId,
        name: p.signaturePositionName,
      }))[0];
    },
    getPosition(item) {
      return { id: item.positionId, name: item.position };
    },
    async getSignatureTypes(sourceType) {
      const res =
        sourceType == SignatureSources.registration
          ? await signatureService.getPreRegisterSignatureTypes()
          : await signatureService.getPostRegisterSignatureTypes();
      this.options.signatureTypes = res.data;
    },
    async preRegistrationValidate() {
      const firstSignatureIsValid = await this.$refs.firstSignaturePanel.validateModel();
      const secondSignatureIsValid = await this.$refs.secondSignaturePanel.validateModel();

      return firstSignatureIsValid && secondSignatureIsValid;
    },
    async getPreRegistrationData() {
      const firstPanelData = await this.$refs.firstSignaturePanel.submitSignature();
      const secondPanelData = await this.$refs.secondSignaturePanel.submitSignature();

      return [firstPanelData, secondPanelData];
    },
    async postRegistrationValidate() {
      let isValid = true;
      let count = await this.$refs[`signature-panel`].length;
      for (let i = 0; i < count; i++) {
        const validate = await this.$refs[`signature-panel`][i].validateModel();
        if (!validate) isValid = false;
      }
      return isValid;
    },
    async getPostRegistrationData() {
      let data = [];
      let count = await this.$refs[`signature-panel`].length;
      for (let i = 0; i < count; i++) {
        data.push(await this.$refs[`signature-panel`][i].submitSignature());
      }
      return data;
    },
    async save() {
      try {
        let isValid = false;
        if (this.showPreRegister) {
          isValid = await this.preRegistrationValidate();
          this.sourceTypeId = SignatureSources.registration;
        }
        if (this.showPostRegister) {
          isValid = await this.postRegistrationValidate();
          this.sourceTypeId = SignatureSources.postRegistration;
        }

        if (!isValid) return false;

        const data = this.showPreRegister
          ? await this.getPreRegistrationData()
          : await this.getPostRegistrationData();

        const selectedRegStudent = this.studentPreRegistry;

        const formdata = new FormData();

        formdata.append(
          `signatureViewModel.postRegStudentId`,
          selectedRegStudent.isPostRegistry
            ? selectedRegStudent.regStudentPostRegistryId
            : selectedRegStudent.regStudentId
        );
        formdata.append(
          `signatureViewModel.IsPostRegister`,
          this.sourceTypeId === SignatureSources.postRegistration
        );

        data.forEach((item, i) => {
          formdata.append(
            `signatureViewModel.signaturesDto[${i}].studentSieId`,
            item.studentSieId
          );
          formdata.append(
            `signatureViewModel.signaturesDto[${i}].signatureType`,
            item.signatureType
          );
          formdata.append(
            `signatureViewModel.signaturesDto[${i}].positionId`,
            item.positionId
          );
          formdata.append(
            `signatureViewModel.signaturesDto[${i}].signatureSource`,
            this.sourceTypeId
          );
          formdata.append(
            `signatureViewModel.signaturesDto[${i}].tutorName`,
            item.tutorName
          );
          formdata.append(
            `signatureViewModel.signaturesDto[${i}].file`,
            item.file
          );
          formdata.append(
            `signatureViewModel.signaturesDto[${i}].attendanceGroupId`,
            item.attendanceGroupId
          );

          formdata.append(
            `signatureViewModel.signaturesDto[${i}].email`,
            item.email
          );
        });

        const studentSieId = this.$store.getters['$_student/StudentSie'];
        const { data: rejectedEvaluationIds } = await this.$ApiGet(
          '/api/studentevaluation/getstudentrejectedevaluation',
          {
            StudentSieID: studentSieId,
          }
        ).catch((e) => {
          this.response = e;
          return { data: null };
        });

        if (rejectedEvaluationIds.length == 0) {
          return this.saveSignatures(formdata);
        }

        // first we save the signature
        await this.saveSignatures(formdata);
        // then we show the modal to generate the referral
        let isRedirectNeeded = await this.ShowCancelModal(
          'Confirmación',
          '¿Desea generar un referido de evaluación independiente a través del mecanismo de remedio provisional?',
          'Si',
          'No'
        );

        if (!isRedirectNeeded) return;

        this.$router.push({
          name: `MainCreateRpRequest`,
          params: { StudentSieId: studentSieId, From: 'registry' },
          query: { RejectedEvaluationIds: rejectedEvaluationIds },
        });
      } catch (err) {
        this.ShowToast('', err.response?.data?.message || err.message, 'error');
      }
    },
    async saveSignatures(formdata) {
      const res = await signatureService.saveStudentTutorSignature(formdata);

      if (res && res?.data) this.ShowToast('Proceso Exitoso', '', 'success');

      this.isReadOnlyMode = true;

      const resHistory = await StudentService.getHistorySign(
        store.getters.SelectedStudent.studentId
      );
      this.dataSign = resHistory.data;
      this.$emit('set-button-save-visibility', !this.showHistory);

      if (this.sourceTypeId === SignatureSources.postRegistration) {
        if (res?.data) {
          this.setStudentPreRegistry({
            ...this.$store.state.$_student.selectedStudentPreRegistry,
            statusId:
              res.data === 'Elegible'
                ? StudentStatuses.Elegible
                : res.data === 'NonElegible'
                ? StudentStatuses.NoElegible
                : null,
          });
          this.setSelectedStudentStatus(res.data);
        }
        this.goToPostRegisterTab();
      }
    },
    ...mapMutations(['setSelectedStudentStatus', 'setStudentPreRegistry']),
  },
};
</script>
<style scoped lang="scss">
.block-spacing {
  margin-bottom: 30px;
}
.block-spacing-extended {
  margin-bottom: 100px;
}
.mode-panel {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  opacity: 1;
  padding: 25px;
}
.custom-dropdown >>> .v-select {
  background: #fff;
}
.custom-dropdown >>> .was-Invalidated {
  background-color: #f7d7da;
}
.vertical-line {
  border-left: 2px solid #dfe9e4;
  height: 50px;
}
.ml {
  margin-left: 70px;
}
</style>
